export const INIT_DEDUCTIBLES = 'deductibles/INIT_DEDUCTIBLES';
export const UNSET_DEDUCTIBLES = 'deductibles/UNSET_DEDUCTIBLES';

export const unsetDeductibles = () => ({
    type: UNSET_DEDUCTIBLES,
})

export const initDeductibles = payload => ({
    type: INIT_DEDUCTIBLES,
    payload,
})

